import React from 'react';
import { Card, CardBody } from 'reactstrap';
import CapabilityTree from './CapabilityTree';

function CapabilitySetHierarchy({
  capabilitySet,
  onAddCapability,
  onEditCapability,
  onMoveCapability,
  onRepositionCapabilities,
}) {
  return (
    <Card>
      <CardBody>
        <CapabilityTree
          capabilitySet={capabilitySet}
          capabilities={capabilitySet.capabilities}
          onAddCapability={onAddCapability}
          onEditCapability={onEditCapability}
          onMoveCapability={onMoveCapability}
          onRepositionCapabilities={onRepositionCapabilities}
        />
      </CardBody>
    </Card>
  );
}

export default CapabilitySetHierarchy;
